module.exports = "<footer class=\"app-footer\">\r\n  <span>Empyrean License {{licsenseServicesVersion}} &copy; 2018 <a href=\"http://empyrean-solutions.com/\">Empyrean Solutions</a></span>\r\n  <span class=\"ml-auto\"> <a href=\"http://empyrean-solutions.com/\">Empyrean Solutions</a></span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-footer/app-footer.component.html
// module id = ./src/app/components/app-footer/app-footer.component.html
// module chunks = main